import { Map } from 'immutable';

import { isEmpty } from 'utils/isEmpty';

export function isTiposValues(value, strValues) {
    if (!value) return true;
    const strValue = value.toString();
    return !strValues
        .split(';')
        .filter((v) => !!v)
        .includes(strValue);
}

export function getLegacyFormErrors(schema, entity, dynamic) {
    let errors = Map();
    let firstErrorField = null;

    schema.forEach((element) => {
        element.tabFields.forEach((field) => {
            if (field.dataType === 'break') return;
            let id = typeof field.id === 'object' ? field.id.id : field.id;
            id = id.toLowerCase();
            const readOnly = field.readOnly && entity.get('id');

            if (
                field.mandatory &&
                !readOnly &&
                isEmpty(entity.get(id)) &&
                (isEmpty(field.TiposEntity) ||
                    field.strTiposEntity === -1 ||
                    field.strTiposEntity === '-1' ||
                    (!isEmpty(field.TiposEntity) &&
                        !isTiposValues(
                            dynamic.get(field.TiposEntity.toLowerCase()),
                            field.strTiposEntity,
                        )))
            ) {
                errors = errors.set(id.toLowerCase(), '  ');
                if (!firstErrorField) {
                    firstErrorField = id.toLowerCase();
                }
            }
        });
    });

    return { errors, firstErrorField };
}
